import React, { Component } from 'react';
import { connect } from 'react-redux';
import Popover from '../../components/uielements/popover';
import IntlMessages from '../../components/utility/intlMessages';
import userpic from '../../image/user1.png';
import authAction from '../../redux/auth/actions';
import { Icon, Input } from 'antd';
import TopbarDropdownWrapper from './topbarDropdown.style';
import Modal from "../../components/mycomponents/modals/Modal"
import Form from '../../components/uielements/form';
import notification from "../../components/notification"
import FetchHelper from '../../helpers/fetchHelper';
import InputPassword from "../../components/uielements/inputPasswordNumber"

//import {Link} from 'react-router-dom';
const { logout } = authAction;

class TopbarUser extends Component {
  constructor(props) {
    super(props);
    this.handleVisibleChange = this.handleVisibleChange.bind(this);
    this.hide = this.hide.bind(this);
    this.state = {
      visible: false,
      activeChangePassword:false
    };
  }
  hide() {
    this.setState({ visible: false });
  }
  handleVisibleChange() {
    this.setState({ visible: !this.state.visible });
  }
  componentDidMount(){
    this.retrieveData();
  }
  retrieveData(){
  }
  saveRef = (object, name) => {
    this[name] = object;
  }

  toggleModal = (name, m, obj = null) => {
    if (this[name] && this[name].toggle) {
      this[name].toggle(m, obj);
    }
  }

  handleOk = e => {
    const { getFieldDecorator, getFieldValue, setFieldsValue, validateFields } = this.props.form;

    validateFields((err, values) => {
      if(err){
        return
      }
      if (values.newPassword != values.repeatNewPassword){
        notification('warning', 'Las contraseñas no coinciden');
        return
      }

      let body = {
        password: String(values.password),
        newPassword: String(values.newPassword),
        username: this.props.user.codigoTitular
      }
      FetchHelper.httpRequest('PUT', `medioPago/pin`, body).then(result => {
        if (result.error) {
          notification('warning', result.error_msg);
        } else {
          if(result.data.codigo == "3000"){
            notification("error", result.data.mensaje)
          } else{
            notification('success', 'Cambios realizados correctamente');
            e.toggle && e.toggle()
          }
        }
      });

    })
  };


  RenderContent = (props) => {
    const { getFieldDecorator, getFieldValue, setFieldsValue } = this.props.form;
    
    return (
      <Form>
        <Form.Item style={{ margin: 0 }} label="Contraseña actual">
          {getFieldDecorator('password', {
            rules: [
              {
                required: true,
                message: 'Ingresa el motivo la contraseña actual',
              }
            ],
            initialValue: ""
          })(
            <InputPassword placeholder='Ingresa la contraseña actual' maxLength={60}  />
          )}
        </Form.Item >
        <Form.Item style={{ margin: 0 }} label="Nueva contraseña">
          {getFieldDecorator('newPassword', {
            rules: [
              {
                required: true,
                message: 'Ingresa la nueva contraseña',
              }
            ],
            initialValue: ""
          })(<InputPassword placeholder='Ingresa la  nueva contraseña' maxLength={60} />)}
        </Form.Item >
        <Form.Item style={{ margin: 0 }} label="Repite la nueva contraseña">
          {getFieldDecorator('repeatNewPassword', {
            rules: [
              {
                required: true,
                message: 'Repite la nueva contraseña',
              }
            ],
            initialValue: ""
          })(<InputPassword placeholder='Repite la nueva contraseña' maxLength={60} />)}
        </Form.Item >
      </Form>
    )
  }

  render() {
    const {user} = this.props
    const content = (
      <TopbarDropdownWrapper className="isoUserDropdown">
        {/*
          <Link className="isoDropdownLink" to='/dashboard'>
            <IntlMessages id="topbar.settings" />
          </Link>
        */}
        {
          user ?
          <div className="isoDropdownUser">
            <img alt="userpic" src={userpic} height={35}/>
            <div style={{justifyContent:'center', display:'flex', alignItems:'end', width:'100%'}}>
              <h3 className="title"><b>{user.apellido}, {user.nombre}</b><br/><small>{user.sector?'Sector: '+user.sector.nombre:''}</small></h3>
            </div>
          </div>
          :
          null
        }
        {/*
          <a className="isoDropdownLink" href="# ">
            <IntlMessages id="topbar.help" />
          </a>
          */}

        <a className="isoDropdownButton" onClick={() => this.toggleModal('modal', {})} href="# ">
          <Icon className="icon" type="key"/>
          <span>Cambiar contraseña</span>
        </a>
        <a className="isoDropdownButton" onClick={this.props.logout} href="# ">
          <Icon className="icon" type="logout"/>
          <IntlMessages id="topbar.logout" />
        </a>
        <Modal
          style={{ top: 20 }}
          ref={(e) => this.saveRef(e, 'modal')}
          width={'30%'}
          Content={this.RenderContent}
          onOk={this.handleOk}
          title={'¿Desea cambiar la contraseña?'}
          okText={'Aceptar'}
          cancelText={'Cancelar'} />
      </TopbarDropdownWrapper>
    );

    return (
      <Popover
        content={content}
        trigger="click"
        visible={this.state.visible}
        onVisibleChange={this.handleVisibleChange}
        arrowPointAtCenter={true}
        placement="bottomLeft"
      >
        <div className="isoIconWrapper">
          <Icon
            type="user"
          />
        </div>
      </Popover>
    );
  }
}


const MyComponentTopbarUser = Form.create()(TopbarUser);
export default connect(
  null,
  { logout }
)(MyComponentTopbarUser);
